import React from 'react';
import chefHat from 'src/assets/svg/chef-hat.svg';
import customer from 'src/assets/svg/customer.svg';
import styled from 'styled-components';
import { BorderRadius, Colors, FontSize, ScreenWidth } from 'web-common/src/shared/styles';
import { Container } from '../../chat/components/EmptyStateIndicator/styles';
import { WaitlistType } from '../../gqlReactTypings.generated.d';

interface IProps {
  rank: number;
  type: WaitlistType;
  numBehind: number;
  /** Inline styles. */
  style?: React.CSSProperties;
}
const RankContainer = styled(Container)`
  border-radius: ${BorderRadius.BUTTON};
  @media (max-width: ${ScreenWidth.SMALL}) {
    width: 100%;
    margin-bottom: 10px;
  }
  @media (min-width: ${ScreenWidth.SMALL}) {
    width: 50%;
  }
  margin: 0px;
  padding: 0px;
  justify-content: space-evenly;
  display: flex;
  flex-direction: column;
`;
const RankNumLabelContainer = styled.div`
  height: 50px;
  line-height: 50px;
  display: flex;
  margin-top: 3px;
  gap: 10px;
`;
const RankNumber = styled.div`
  color: ${Colors.RADISH};
  font-size: ${FontSize.XXL};
  height: 100%;
`;
const RankLabel = styled.div`
  font-size: ${FontSize.XS};
  height: 100%;
`;
const RankLabelP = styled.p`
  line-height: normal;
  display: inline-block;
  vertical-align: middle;
  width: 90px;
  margin-bottom: 0px;
`;
const RankInfo = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-evenly;
`;
export const WaitlistRankCard = (props: IProps) => {
  const { rank, numBehind, type, ...otherProps } = props;
  const term = type === WaitlistType.Shef ? 'Cooks' : 'Customers';
  const icon = type === WaitlistType.Shef ? chefHat : customer;
  return (
    <RankContainer {...otherProps}>
      <RankInfo>
        <RankNumLabelContainer>
          <RankNumber>{rank}</RankNumber>
          <RankLabel>
            <img src={icon} alt={type} style={{ height: '24px', marginTop: '-3px' }} />
          </RankLabel>
          <RankLabel>
            <RankLabelP>
              {term}
              <br />
              ahead of you
            </RankLabelP>
          </RankLabel>
        </RankNumLabelContainer>
        <RankNumLabelContainer>
          <RankNumber>{numBehind}</RankNumber>
          <RankLabel>Behind</RankLabel>
        </RankNumLabelContainer>
      </RankInfo>
    </RankContainer>
  );
};
